import { v4 as uuidv4 } from 'uuid';

// One correlation ID per browser session, shared by every API call (sent as
// the x-correlation-id header in useAxios.ts) so a frontend session's logs
// can be matched to the same backend logs. Call resetCorrelationId() on
// logout (see NavBar.tsx) to start a new ID for the next session, since not
// every logout path triggers a full page reload.
let correlationId = uuidv4();

export const getCorrelationId = () => correlationId;

export const resetCorrelationId = () => {
  correlationId = uuidv4();
};
